import logo from './logo.svg';
import logoInvoice from './logo-invoice.png';

import successful from './logo.svg';
import successfulMobile from './logo.svg';

import checkoutSuccess from './logo.svg';
import checkoutSuccessMobile from './logo.svg';

import gmail from './to-gmail.svg';
import outlook from './toOutlook.svg';
import yahoo from './toYahoo.svg';
import protonmail from './toProtonmail.svg';
import aol from './toAol.svg';
import zoho from './toZoho.svg';
import icloud from './toICloud.svg';
import gmx from './toGMX.svg';
import hey from './toHey.svg';
import yandex from './toYandex.svg';
import google from './google.svg';
import facebook from './facebook.svg';
import apple from './apple.svg';
import email from './email.svg';
import lock from './lock.svg';

import edit from './edit.svg';
import check from './check.svg';

import ResendEmailLoader from './resend-email-loader.svg';

import mastercard from './_Mastercard.svg';
import maestro from './_Maestro.svg';
import americanExpress from './_AmericanExpress.svg';
import visa from './_VISA.svg';
import payPal from './_PayPal.svg';

import visa3 from './Visa3.png';

import paymentFailedCard from './_payment-failed-card.svg'
import paymentSuccessfulCard from './_payment-successful-card.svg'

import heartRed from './heart-red.png';
import heartBlue from './heart-blue.png';

/*Plans*/
import plan_0 from './plan_size_0.svg';
import plan_1 from './plan_size_1.svg';
import plan_2 from './plan_size_2.svg';
import plan_3 from './plan_size_2.svg';

import plan_basic from './plan_size_0.svg';
import plan_standard from './plan_size_1.svg';
import plan_premium from './plan_size_2.svg';

const Images = {
  logo,
  logoInvoice,

  successful,
  successfulMobile,

  checkoutSuccess,
  checkoutSuccessMobile,

  gmail,
  outlook,
  yahoo,
  protonmail,
  aol,
  zoho,
  icloud,
  gmx,
  hey,
  yandex,
  google,
  facebook,
  email,
  lock,
  apple,

  edit,
  check,

  mastercard,
  maestro,
  americanExpress,
  visa,
  payPal,

  ResendEmailLoader,

  visa3,

  plan_0,
  plan_1,
  plan_2,
  plan_3,

  plan_basic,
  plan_standard,
  plan_premium,

  paymentFailedCard,
  paymentSuccessfulCard,

  heartRed,
  heartBlue,
};

export default Images;
